import React from 'react';
import { Form, Calendar, Input } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import AppModal from '@/pages/inside/tenant/AppModal';
import { Button } from '@/components/ui/Button';

export const HolidayModal = ({
    open,
    onCancel,
    selectedDate,
    onDateSelect,
    cellRender,
    headerRender,
    holidays = [],
    form,
    onSubmit,
    onDelete,
    createLoading,
    updateLoading,
    deleteLoading,
}) => {
    const isExistingHoliday = !!holidays.find(
        (h) => h.date === selectedDate.format('YYYY-MM-DD') || (h.date && h.date.startsWith(selectedDate.format('YYYY-MM-DD'))),
    );

    return (
        <AppModal
            size="lg"
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', paddingBottom: '8px', borderBottom: '1px solid rgba(0, 0, 0, 0.06)' }}>
                    <CalendarOutlined style={{ color: '#7543dc', fontSize: '20px' }} />
                    <span style={{ fontWeight: 700, fontSize: '18px', color: '#1f2937', letterSpacing: '-0.3px' }}>Set Company Holiday</span>
                </div>
            }
            open={open}
            onCancel={onCancel}
            footer={null}
            styles={{ body: { paddingTop: 20, paddingBottom: 20 } }}
        >
            <div style={{ display: 'flex', gap: '28px', flexWrap: 'wrap', alignItems: 'stretch' }}>
                {/* Left Column: Calendar Container */}
                <div style={{
                    flex: '1 1 340px',
                    boxShadow: '0 4px 20px -2px rgba(117, 67, 220, 0.05), 0 2px 8px -1px rgba(0, 0, 0, 0.03)',
                    border: '1px solid rgba(117, 67, 220, 0.08)',
                    borderRadius: '16px',
                    padding: '16px',
                    background: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                }}>
                    <Calendar
                        fullscreen={false}
                        cellRender={cellRender}
                        onSelect={onDateSelect}
                        value={selectedDate}
                        headerRender={headerRender}
                    />
                </div>

                {/* Right Column: Details & Action Form Container */}
                <div style={{
                    flex: '1 1 300px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '20px',
                    background: '#faf9fe',
                    border: '1px solid rgba(117, 67, 220, 0.06)',
                    borderRadius: '16px',
                    padding: '24px',
                    justifyContent: 'space-between',
                }}>
                    {/* Header Area: Date and Tag */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <div style={{ fontSize: '12px', fontWeight: 600, color: '#8c8c8c', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                            Selected Date
                        </div>
                        <h4 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#1f2937', letterSpacing: '-0.4px' }}>
                            {selectedDate.format('LL')}
                        </h4>
                        <div style={{ marginTop: '4px' }}>
                            {isExistingHoliday ? (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#f5efff', color: '#7543dc', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 600 }}>
                                    <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#7543dc' }} />
                                    Official Holiday Set
                                </div>
                            ) : (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#f3f4f6', color: '#6b7280', padding: '6px 12px', borderRadius: '20px', fontSize: '12px', fontWeight: 500 }}>
                                    <span style={{ display: 'inline-block', width: '6px', height: '6px', borderRadius: '50%', background: '#9ca3af' }} />
                                    No Holiday Set
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Form Area */}
                    <Form form={form} layout="vertical" onFinish={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                        <Form.Item
                            name="title"
                            label={<span style={{ fontWeight: 600, fontSize: '13px', color: '#4b5563' }}>Holiday Title</span>}
                            rules={[{ required: true, message: 'Please enter holiday title' }]}
                            style={{ margin: 0 }}
                        >
                            <Input
                                placeholder="e.g. Eid-ul-Fitr"
                                style={{ borderRadius: '8px', padding: '8px 12px', border: '1px solid rgba(117, 67, 220, 0.15)' }}
                            />
                        </Form.Item>

                        <Form.Item
                            name="description"
                            label={<span style={{ fontWeight: 600, fontSize: '13px', color: '#4b5563' }}>Description</span>}
                            style={{ margin: 0 }}
                        >
                            <Input.TextArea
                                rows={3}
                                placeholder="e.g. Company holiday for celebrations"
                                style={{ borderRadius: '8px', padding: '8px 12px', border: '1px solid rgba(117, 67, 220, 0.15)' }}
                            />
                        </Form.Item>

                        {/* Actions Area */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', marginTop: '12px' }}>
                            {isExistingHoliday ? (
                                <Button
                                    $primary={false}
                                    $dangerOutline
                                    onClick={onDelete}
                                    loading={deleteLoading}
                                    $padding="8px 16px"
                                    $size="13px"
                                    style={{ height: '38px' }}
                                >
                                    Delete
                                </Button>
                            ) : <div />}

                            <Button
                                $primary
                                $blackOnLight
                                htmlType="submit"
                                loading={createLoading || updateLoading}
                                $padding="8px 20px"
                                $size="13px"
                                style={{ height: '38px' }}
                            >
                                {isExistingHoliday ? 'Update Details' : 'Confirm Holiday'}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </AppModal>
    );
};

export default HolidayModal;
